const toaster = new ToastMagic();
const DEFAULT_NOTIFICATION_DURATION = 7000;
window.DEFAULT_NOTIFICATION_DURATION = DEFAULT_NOTIFICATION_DURATION;

window.showNotification = (message, config = {}) => {
    const defaultConfig = {
        type: 'info',
        description: null,
        showCloseBtn: true,
        customBtnText: null,
        customBtnLink: null,
        duration: DEFAULT_NOTIFICATION_DURATION
    };

    const finalConfig = {...defaultConfig, ...config};
    const validTypes = ['info', 'success', 'warning', 'error'];

    if (!validTypes.includes(finalConfig.type)) {
        console.error(`[ToastMagic] Tipo inválido: '${finalConfig.type}'. Fallback para 'info' aplicado.`);
        finalConfig.type = 'info';
    }

    if (finalConfig.customBtnText && !finalConfig.customBtnLink) {
        console.error('[ToastMagic] Botão customizado sem link. O botão será ocultado.');
        finalConfig.customBtnText = null;
    }

    const showOptions = {
        type: finalConfig.type,
        heading: message,
        description: finalConfig.description,
        showCloseBtn: finalConfig.showCloseBtn,
        customBtnText: finalConfig.customBtnText,
        customBtnLink: finalConfig.customBtnLink,
        timeOut: finalConfig.duration,
    }

    if (window.toastMagicConfig) {
        window.toastMagicConfig.timeOut = finalConfig.duration;
    }

    toaster.show(showOptions);
}
